import { Injectable } from '@angular/core';
import { createClient, SupabaseClient } from '@supabase/supabase-js';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class SupabaseService {
  readonly configured = /^https:\/\/[a-z0-9-]+\.supabase\.co\/?$/i.test(environment.supabaseUrl)
    && environment.supabasePublishableKey.startsWith('sb_publishable_');

  private readonly instance: SupabaseClient | null = this.configured
    ? createClient(environment.supabaseUrl.replace(/\/$/, ''), environment.supabasePublishableKey, {
        auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: true }
      })
    : null;

  get client(): SupabaseClient {
    if (!this.instance) {
      throw new Error('Configura la URL y la clave publicable de Supabase en src/environments/environment.ts.');
    }
    return this.instance;
  }
}
